module.exports = __webpack_public_path__ + "media/img/uploads/event-thumb-01-61653fb470f19542551ec7a3d22b6dc5.jpg";